// FIEORegistration.jsx
import React from "react";

export default function FIEORegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            FIEO Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            FIEO Registration Support for Exporters
          </h1>
          <div className="w-20 h-1 bg-cyan-600 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists exporters in obtaining FIEO
            Registration, helping them secure Registration‑cum‑Membership
            Certificates needed to access export incentives and policy
            benefits.[web:430][web:433]
          </p>
          <p className="text-gray-700">
            The service focuses on correct category selection, end‑to‑end online
            filing, and handling of document checks so applications move smoothly
            through verification and approval.[web:430][web:432][web:435]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-cyan-500 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/8867432/pexels-photo-8867432.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Export logistics with containers and ship"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for FIEO Registration
            </h2>
            <p className="text-gray-700 mb-4">
              FIEO membership and RCMC applications generally require core
              identity, tax, and business registration proofs along with basic
              export details.[web:430][web:432][web:433]
            </p>
            <div className="bg-gray-50 border border-cyan-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  IEC certificate (Import Export Code) issued by DGFT, which is
                  mandatory to register as an exporter‑member.[web:430][web:432][web:433]
                </li>
                <li>
                  PAN card of the business or proprietor/partner/company, used
                  for tax identification and membership records.[web:430][web:432][web:433]
                </li>
                <li>
                  Business incorporation or constitution proof, such as
                  Certificate of Incorporation, Partnership Deed, MOA/AOA or
                  similar documents, plus basic address proof.[web:432][web:433][web:434]
                </li>
                <li>
                  Additional items often requested include GST certificate, bank
                  certificate or cancelled cheque, and brief business/export
                  profile details.[web:430][web:432][web:435]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The aim is to simplify FIEO membership so exporters can focus on
              markets while documentation and portal work are handled
              correctly.[web:430][web:435]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-cyan-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Export Compliance Knowledge
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on aligning FIEO membership with IEC, FTP
                  requirements and export promotion council expectations.[web:430][web:432]
                </p>
              </div>

              <div className="border-l-4 border-cyan-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Help in compiling, checking and uploading the correct scans and
                  formats so the online FIEO/RCMC application is complete and
                  clear.[web:431][web:433][web:438]
                </p>
              </div>

              <div className="border-l-4 border-cyan-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing support for responding to queries, renewals, and
                  updates, helping maintain valid FIEO membership over time.[web:435][web:437]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-cyan-600 text-cyan-700 font-medium hover:bg-cyan-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
